import { inject } from '@angular/core';
import { AuthStore } from '@/features/auth-store.service';
import { NAV_ITEMS } from '@/layout/sidebar/app.navigation';

export function resolveHomeUrl(): string | undefined {
  const authStore = inject(AuthStore);

  const firstReachableItem = NAV_ITEMS.find(
    (item) => item.permission === undefined || authStore.hasPermission(item.permission),
  );

  return firstReachableItem?.path;
}
